/**
 * VersionGateBanner — renders the DEF-156 version-gate notification.
 *
 * Placed inside ToastProvider so it can use useToast. Shows a persistent
 * banner at the top of the viewport when a new deploy is detected.
 */

import React, { useState } from 'react';
import useVersionGate from '../../hooks/useVersionGate';

export default function VersionGateBanner() {
  const [update, setUpdate] = useState(null);

  useVersionGate({
    onNewVersion: (info) => setUpdate(info),
  });

  if (!update) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-3 px-4 py-2 text-sm"
      style={{
        backgroundColor: 'var(--color-info-bg)',
        color: 'var(--color-info-text)',
        borderBottom: '1px solid var(--color-info-border, var(--color-border))',
      }}
    >
      <span>A new version is available ({update.currentSha} → {update.newSha})</span>
      <button
        onClick={update.reload}
        className="px-3 py-1 rounded text-xs font-semibold"
        style={{
          backgroundColor: 'var(--color-action-primary)',
          color: 'white',
        }}
      >
        Reload now
      </button>
      <button
        onClick={() => { update.dismiss(); setUpdate(null); }}
        className="text-xs underline"
        style={{ color: 'var(--color-text-muted)' }}
      >
        Later
      </button>
    </div>
  );
}
